import ranges from "./calculation-sets/age-ranges";

// export function resolve(sourceObject, property) {
//   return property ? property.split('.').reduce((o, k) => o && o[k], sourceObject) : '';
// }

// export function generateArrayFromValue(max = 1, min = 1) {
//   const array = Array.from(Array(max), (_, i) => i + min);
//   return array.map(e => ({
//     label: e,
//     value: e,
//   }));
// }

// export function getCurrentValue(data, field, defaultValue = '') {
//   return data?.find(e => e.id === field.id)?.value || defaultValue;
// }

// export function flattenFieldArray(data) {
//   return data?.reduce((r, { items, ...rest}) => {
//     r.push(rest);
//     if (items) r.push(...flattenFieldArray(items));
//     return r;
//   }, [])
// }

export function groupArrayByLetter(data) {
    const sortedData =
        data && data.length > 0
            ? data.sort((a, b) => {
                  return a?.name?.localeCompare(b?.name);
              })
            : [];
    const reducedData = sortedData.reduce((r, e) => {
        const key = e?.name && e?.name[0];
        if (!r[key]) r[key] = [];
        r[key].push(e);
        return r;
    }, {});
    return Object.entries(reducedData);
}

// export function compare(a, o, b) {
//   const operator = o || '===';
//   const operators = {
//       '===':       (l, r) => l === r,
//       '!==':       (l, r) => l !== r,
//       '<':         (l, r) => l < r,
//       '>':         (l, r) => l > r,
//       '<=':        (l, r) => l <= r,
//       '>=':        (l, r) => l >= r,
//       'typeof':    (l, r) => l === typeof r,
//       'nottypeof': (l, r) => l !== typeof r,
//   }
//   return operators[operator](a, b);
// }

export function getRegimenStepItems(state) {
    const items = state.navigationItems;

    return items
        ?.filter((e) => !e.hiddenFromNavigation)
        .map((step) => {
            const complete =
                step.complete || step?.requiredFields.length > 0
                    ? step?.requiredFields.every((id) => state[id])
                    : false;
            const disabled = step?.dependant
                ? !items?.find((e) => e.id === step.dependant)?.complete
                : false;

            return {
                ...step,
                complete,
                disabled,
            };
        });
}

export function makeBold(input) {
    // This is used to bold any phrases that are wrapped in to asterisks.
    // i.e. **milk** would return in strong tags
    // This is used on the product information page.
    return input.replace(/\*\*(\S[^**]+\S)\*\*/g, "<strong>$1</strong>");
}

export function makeItalic(input) {
    // This is used to add italic any phrases that are wrapped in to underscores.
    // i.e. _milk_ would return in em tags
    // This is used on the product information page.
    return input.replace(/_(\S[^**]+\S)_/g, "<em>$1</em>");
}

export function formatText(input) {
    // This is just a combination of makeBold() and makeItalic()
    // This is used on the product information page.
    let formattedText = input;
    formattedText = makeBold(formattedText);
    formattedText = makeItalic(formattedText);
    return formattedText;
}

export function toCamelCase(str) {
    return str
        ?.split(" ")
        .map((word, index) => {
            // If it is the first word make sure to lowercase all the chars.
            if (index === 0) {
                return word.toLowerCase();
            }
            // If it is not the first word only upper case the first char and lowercase the rest.
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join("");
}

export function toTitleCase(str) {
    if (str.length > 0) {
        return str
            .trim()
            .split(" ")
            .map((w) =>
                w.length > 0 ? w[0].toUpperCase() + w.substring(1) : "",
            )
            .join(" ");
    }
    return "";
}

export function getResultByGenderAge({ age, gender, maleData, femaleData }) {
    let result;
    const data = gender === "male" ? maleData : femaleData;

    if (data) {
        data.forEach((e) => {
            if (age >= e.age[0] && age <= e.age[1]) {
                result = e.value;
            }
            return;
        });
    }

    return result;
}

// This can be used to return correct nutrient values maps
// this can be reused as nutreient values have the same structure,
// while minerals and proteins tend to have varied structures
export function generateNutrientValues({
    ZeroToThreeMonths,
    FourToSixMonths,
    SevenToNineMonths,
    TenToTwelveMonths,
    OneToThreeYears,
    FourToSixYears,
    SevenToTenYears,
    ElevenToFourteenYears,
    FifteenToEighteenYears,
    NineteenToFiftyYears,
    FiftyPlus,
}) {
    return [
        {
            age: [ranges.from.zero, ranges.to.fourMonths],
            value: ZeroToThreeMonths,
        },
        {
            age: [ranges.from.fourMonths, ranges.to.sevenMonths],
            value: FourToSixMonths,
        },
        {
            age: [ranges.from.sevenMonths, ranges.to.tenMonths],
            value: SevenToNineMonths,
        },
        {
            age: [ranges.from.tenMonths, ranges.to.oneYear],
            value: TenToTwelveMonths,
        },
        {
            age: [ranges.from.oneYear, ranges.to.fourYears],
            value: OneToThreeYears,
        },
        {
            age: [ranges.from.fourYears, ranges.to.sevenYears],
            value: FourToSixYears,
        },
        {
            age: [ranges.from.sevenYears, ranges.to.elevenYears],
            value: SevenToTenYears,
        },
        {
            age: [ranges.from.elevenYears, ranges.to.fifteenYears],
            value: ElevenToFourteenYears,
        },
        {
            age: [ranges.from.fifteenYears, ranges.to.nineteenYears],
            value: FifteenToEighteenYears,
        },
        {
            age: [ranges.from.nineteenYears, ranges.to.fiftyYears],
            value: NineteenToFiftyYears,
        },
        {
            age: [ranges.from.fiftyYears, ranges.to.max],
            value: FiftyPlus,
        },
    ];
}

export function generateNutrientValuesMagnesium({
    ZeroToThreeMonths,
    FourToSixMonths,
    SevenToNineMonths,
    TenToTwelveMonths,
    OneToThreeYears,
    FourToSixYears,
    SevenToTenYears,
    ElevenToFourteenYears,
    FifteenToEighteenYears,
    NineteenToFiftyYears,
    FiftyPlus,
}) {
    return [
        {
            age: [ranges.from.zero, ranges.to.fourMonths],
            value: ZeroToThreeMonths,
        },
        {
            age: [ranges.from.fourMonths, ranges.to.sevenMonths],
            value: FourToSixMonths,
        },
        {
            age: [ranges.from.sevenMonths, ranges.to.tenMonths],
            value: SevenToNineMonths,
        },
        {
            age: [ranges.from.tenMonths, ranges.to.oneYear],
            value: TenToTwelveMonths,
        },
        {
            age: [ranges.from.oneYear, ranges.to.threeYears],
            value: OneToThreeYears,
        },
        {
            age: [ranges.from.threeYears, ranges.to.sevenYears],
            value: FourToSixYears,
        },
        {
            age: [ranges.from.sevenYears, ranges.to.tenYears],
            value: SevenToTenYears,
        },
        {
            age: [ranges.from.tenYears, ranges.to.fifteenYears],
            value: ElevenToFourteenYears,
        },
        {
            age: [ranges.from.fifteenYears, ranges.to.eighteenYears],
            value: FifteenToEighteenYears,
        },
        {
            age: [ranges.from.eighteenYears, ranges.to.fiftyYears],
            value: NineteenToFiftyYears,
        },
        {
            age: [ranges.from.fiftyYears, ranges.to.max],
            value: FiftyPlus,
        },
    ];
}

// Normalizes nutrient names by stripping embedded units from old format
export function normalizeNutrientName(name, unit) {
    if (!name) return "";

    const nameLower = name.toLowerCase().trim();
    const unitLower = unit ? unit.toLowerCase().trim() : "";

    // Normalize µ/μ to "mc" for comparison purposes
    const nameLowerNormalized = nameLower.replace(/[\u00B5\u03BC]/g, "mc");
    const unitLowerNormalized = unitLower.replace(/[\u00B5\u03BC]/g, "mc");

    // Strip unit suffix from old format (e.g., "protein g" -> "protein", "vitamin A mcg" -> "vitamin A")
    if (
        unitLowerNormalized &&
        nameLowerNormalized.endsWith(` ${unitLowerNormalized}`)
    ) {
        return name.substring(0, name.length - unit.length).trim();
    }

    // Also check without normalization for exact match
    if (unitLower && nameLower.endsWith(` ${unitLower}`)) {
        return name.substring(0, name.length - unit.length).trim();
    }

    // Handle "protein en%" special case
    if (nameLower.endsWith(" en%")) {
        return name.substring(0, name.length - 4).trim();
    }

    return name.trim();
}

// Creates unique key for nutrient (e.g., "protein_g", "protein_percent")
export function createNutrientKey(name, unit) {
    if (!name) return "";

    const normalized = normalizeNutrientName(name, unit).toLowerCase().trim();
    const unitKey = unit ? `_${normalizeUnit(unit)}` : "";

    return normalized.replace(/[^a-z0-9]/g, "") + unitKey;
}

// Normalize unit strings so µg, μg, and mcg all produce the same key
function normalizeUnit(unit) {
    if (!unit) return "";
    // Replace micro sign (U+00B5) and greek mu (U+03BC) with "mc"
    let normalized = unit.replace(/[\u00B5\u03BC]/g, "mc");
    return normalized.toLowerCase().replace(/[^a-z0-9]/g, "");
}

// Parses IndexedDB nutrient format to {name, unit, amount}
function parseNutrientEntry(nutrientArray) {
    if (!nutrientArray || !Array.isArray(nutrientArray)) return null;

    const nameObj = nutrientArray.find((item) => item?.name === "nutrientName");
    const unitObj = nutrientArray.find((item) => item?.name === "nutrientUnit");
    const amountObj = nutrientArray.find(
        (item) => item?.name === "nutrientAmount",
    );

    return {
        name: nameObj?.value || "",
        unit: unitObj?.value || "",
        amount: amountObj?.value || "",
    };
}

// Aligns nutrients across multiple products for comparison view
export function alignProductNutrients(products, categoryKey) {
    if (!products || products.length === 0) return [];
    if (products.length === 1) {
        return products.map((p) => p[categoryKey]);
    }

    // Build unified list of all nutrients across products
    const nutrientMap = new Map();

    products.forEach((product, productIndex) => {
        const nutrients = product[categoryKey];
        if (!nutrients || !Array.isArray(nutrients)) return;

        nutrients.forEach((nutrientArray) => {
            const parsed = parseNutrientEntry(nutrientArray);
            if (!parsed || !parsed.name) return;

            const key = createNutrientKey(parsed.name, parsed.unit);

            if (!nutrientMap.has(key)) {
                const normalized = normalizeNutrientName(
                    parsed.name,
                    parsed.unit,
                );
                nutrientMap.set(key, {
                    name: normalized,
                    unit: parsed.unit,
                    displayName: toTitleCase(normalized),
                    indices: [productIndex],
                });
            } else {
                const entry = nutrientMap.get(key);
                if (!entry.indices.includes(productIndex)) {
                    entry.indices.push(productIndex);
                }
            }
        });
    });

    const orderedKeys = Array.from(nutrientMap.keys());

    // Map each product's nutrients to aligned rows
    const alignedProducts = products.map((product) => {
        const nutrients = product[categoryKey];
        if (!nutrients) return [];

        const productNutrientMap = new Map();
        nutrients.forEach((nutrientArray) => {
            const parsed = parseNutrientEntry(nutrientArray);
            if (!parsed || !parsed.name) return;

            const key = createNutrientKey(parsed.name, parsed.unit);
            productNutrientMap.set(key, nutrientArray);
        });

        return orderedKeys.map((key) => {
            if (productNutrientMap.has(key)) {
                return productNutrientMap.get(key);
            } else {
                const nutrientInfo = nutrientMap.get(key);
                return [
                    { name: "nutrientName", value: nutrientInfo.displayName },
                    { name: "nutrientUnit", value: nutrientInfo.unit },
                    { name: "nutrientAmount", value: "-" },
                ];
            }
        });
    });

    return alignedProducts;
}
